export const setCookie = (cname, cvalue, isDelete) => {
  const d = new Date()
  d.setTime(isDelete ? d.getTime() - 1 : d.getTime() + (24 * 60 * 60 * 1000))
  const expires = `expires=${d.toGMTString()}`
  document.cookie = `${cname}=${cvalue}; ${expires}; path=/;`
}

export const getCookie = cname => {
  const name = `${cname}=`
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    const c = ca[i].trim()
    if (c.indexOf(name) === 0) { return c.substring(name.length, c.length) }
  }
  return ''
}

export const deleteCookie = cname => {
  setCookie(cname, '', true)
}
